import { useQuery } from "@tanstack/react-query"
import { getAdminToBuyerQuotationById } from "@/lib/api/quotation.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetAdminToBuyerQuotationById(id: string, enabled: boolean = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["admin-buyer-quotation-detail", id],
    queryFn: () => getAdminToBuyerQuotationById(id, accessToken!),
    enabled: !!accessToken && !!id && enabled,
    staleTime:0,
  })
}
